export class _StoredFile { // collection
  name: string; // file name, as uploaded
  // these come from Storage Upload Response:
  contentType: string; // TODO: does client have this? it comes from object once uploaded
  path: string; // file path, reference to object in storage (files/<order id>/<printing group>/<file id>/<file name>)
  size: number; // file size, in bytes
  url: string; // download url

}

export class StoredFile extends _StoredFile{ // collection
  createdAt: Date;
  updatedAt: Date;
  version: number;
  ref: Ref;


}

export interface DeviceFile {
  lastModified: number; //(timestamp ?)
  name: string;
  size: number;
  type: string;
}

export interface Ref {
  id: string;
  col: string;
  type?: string;
}

export class FileUtils{
  static icon(type){
    switch (type) {
      case  "application/pdf":
        return "assets/images/file-type/adobe.png";
        break;
      case  "application/vnd.ms-powerpoint":
        return "assets/images/file-type/powerpoint.png";
        break;
        case "application/vnd.ms-excel":
        case "application/vnd.ms-excel":
        case "application/vnd.ms-excel":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
        case "application/vnd.ms-excel.sheet.macroEnabled.12":
        case "application/vnd.ms-excel.template.macroEnabled.12":
        case "application/vnd.ms-excel.addin.macroEnabled.12":
        case "application/vnd.ms-excel.sheet.binary.macroEnabled.12":
        return "assets/images/file-type/excel.png";
        break;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
      case "application/vnd.ms-word.document.macroEnabled.12":
      case "application/vnd.ms-word.template.macroEnabled.12":
        return "assets/images/file-type/word.png";
        break;
      case  "image/jpeg":
      case  "image/png":
      case  "image/gif":
      case  "image/jpg":
      case  "image/bmp":
      case  "image/tif":
        return "assets/images/file-type/image.png";
        break;

      default:
        return "assets/images/file-type/file.png";
    }

  }
}